import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { ProductSampleSpec } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ProductSampleSpecService extends TmsWebBaseEditService<ProductSampleSpec, ProductSampleSpec> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('SampleSpec', $localize`Sample Spec`, httpService, notificationService);
  }
}
